<template>
  <!-- One slim row per item; the specifics live on the page the link opens, not here. -->
  <div v-if="items.length" class="d-flex flex-column gap-2 mb-4">
    <div
      v-for="(item, index) in items"
      :key="index"
      class="cg-open-item d-flex align-items-center gap-3 px-3 py-2 border rounded small"
    >
      <font-awesome-icon
        :icon="item.tone === 'warn' ? 'circle-exclamation' : 'clock'"
        :class="
          item.tone === 'warn' ? 'cg-open-item__warn' : 'text-body-secondary'
        "
        class="flex-shrink-0"
      />
      <span class="flex-grow-1 min-w-0 text-truncate">{{ item.text }}</span>
      <button
        type="button"
        class="btn btn-sm btn-link p-0 text-nowrap fw-semibold"
        @click="$emit('action', item.action)"
      >
        {{ item.cta }}
        <font-awesome-icon icon="arrow-right" class="ms-1" />
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import type {
  OpenItem,
  OpenItemAction,
} from "@/compliance_groups/fixture/derive";

defineProps<{ items: OpenItem[] }>();
defineEmits<{ action: [action: OpenItemAction] }>();
</script>

<style scoped lang="scss">
.cg-open-item {
  background: var(--phoenix-emphasis-bg);
}
// Ochre marks the item as needing attention; the row itself stays neutral.
.cg-open-item__warn {
  color: var(--phoenix-orange-500, #c08e3a);
}
</style>
